import { CURRENT_ORDER_LOCAL_STORAGE_KEY } from '../constants';

export function clearCurrentOrder(): void {
  localStorage.removeItem(CURRENT_ORDER_LOCAL_STORAGE_KEY);
}
